import { makeApiRequest, parseFullSymbol, generateSymbol } from "./helpers.js";
import useData from "src/use/data";
import { LocalStorage } from "quasar";
import { subscribeOnStream, unsubscribeFromStream } from "./streaming.js";

const lastBarsCache = new Map();
const {
  intraHistoryDataSearch,
  intraHistoryDataSearchNew,
  historyDataSearch,
  historyDataSearchNew,
  allSymbol,
} = useData();

const configurationData = {
  supported_resolutions: [
    "6M",
    "3M",
    "2M",
    "1M",
    "2W",
    "1W",
    "4D",
    "3D",
    "2D",
    "1D",
    "4H",
    "3H",
    "120",
    "60",
    "45",
    "30",
    "15",
    "5",
    "1",
  ],
  supported_resolutions_for_guest: ["1D", "1W", "2W", "1M", "2M", "3M"],
  exchanges: [
    {
      value: "NEPSE",
      name: "Nepal Stock Exchange",
      desc: "Nepal Stock Exchange",
    },
  ],
  symbols_types: [
    { name: "All types", value: "" },
    { name: "Stock", value: "stock" },
    { name: "Index", value: "index" },
  ],
};
async function getAllSymbols() {
  const data = (await allSymbol()).data.filter((item) => item.type != "sector");
  let allSymbols = [];

  for (const exchange of configurationData.exchanges) {
    for (let i = 0; i < data.length; i++) {
      const symbol = generateSymbol(data[i].type, data[i].symbol, data[i].name);
      allSymbols = [
        ...allSymbols,
        {
          symbol: symbol.short,
          full_name: symbol.short,
          description: symbol.full,
          exchange: exchange.value,
          type: symbol.type,
        },
      ];
    }
  }
  return allSymbols;
}
let symbolCache;

export default {
  onReady: (callback) => {
    // console.log("[onReady]: Method call");
    setTimeout(() => callback(configurationData));
  },
  searchSymbols: async (
    userInput,
    exchange,
    symbolType,
    onResultReadyCallback
  ) => {
    let symbols;
    if (symbolCache) {
      symbols = symbolCache;
    } else {
      // If symbols are not cached, fetch them from the API
      symbols = await getAllSymbols();
      // Cache the fetched symbols'
      symbolCache = symbols;
    }

    const newSymbols = symbols.filter((symbol) => {
      const isExchangeValid =
        exchange === "NEPSE" || symbol.exchange === exchange;
      const isFullSymbolContainsInput =
        symbol.symbol.toLowerCase().indexOf(userInput.toLowerCase()) !== -1;
      const isFullNameContainsInput = symbol.description
        .toLowerCase()
        .includes(userInput.toLowerCase());
      const stockIndexFilter =
        symbolType == "" ? true : symbol.type == symbolType;
      return (
        isExchangeValid &&
        (isFullSymbolContainsInput || isFullNameContainsInput) &&
        stockIndexFilter
      );
    });
    onResultReadyCallback(newSymbols);
  },

  resolveSymbol: async (
    symbolName,
    onSymbolResolvedCallback,
    onResolveErrorCallback,
    extension
  ) => {
    let symbols;
    if (symbolCache) {
      symbols = symbolCache;
    } else {
      // If symbols are not cached, fetch them from the API
      symbols = await getAllSymbols();
      // Cache the fetched symbols
      symbolCache = symbols;
    }

    // symbols.forEach((item) => console.log("item is here", item));
    const symbolItem = symbols.find(
      ({ full_name }) => full_name === symbolName
    );

    if (!symbolItem) {
      // console.log("[resolveSymbol]: Cannot resolve symbol", symbolName);
      onResolveErrorCallback("cannot resolve symbol");
      return;
    }
    const symbolInfo = {
      ticker: symbolItem.full_name,
      name: symbolItem.symbol,
      description: symbolItem.description,
      type: symbolItem.type,
      session: "1;1100-1500:1,2,3,4,5,6",
      timezone: "Asia/Kathmandu",
      exchange: symbolItem.exchange,
      minmov: 10,
      pricescale: 100,
      minmov: 1,
      minmovement: 1,
      minmovement2: 0,
      has_intraday: true,
      // has_no_volume: false,
      has_dwn: true,
      has_weekly_and_monthly: false,
      supported_resolutions: LocalStorage.getItem("token")
        ? configurationData.supported_resolutions
        : configurationData.supported_resolutions_for_guest,
      // : configurationData.supported_resolutions_for_guest,
      visible_plots_set: "ohlcv",
      // data_status: "streaming",
      intraday_multipliers: ["1"],
      session_regular: "0900",
      volume_precision: 2,
      scale: 2,
      data_status: "streaming",
    };
    setTimeout(() => {
      onSymbolResolvedCallback(symbolInfo);
    }, 0);
  },
  // ...

  getBars: async (
    symbolInfo,
    resolution,
    periodParams,
    onHistoryCallback,
    onErrorCallback
  ) => {
    const { from, to, countBack, firstDataRequest } = periodParams;
    const parsedSymbol = parseFullSymbol(symbolInfo.full_name);

    if (
      resolution == "240" ||
      resolution == "180" ||
      resolution == "120" ||
      resolution == "60" ||
      resolution == "45" ||
      resolution == "30" ||
      resolution == "15" ||
      resolution == "5" ||
      resolution == "1"
    ) {
      try {
        intraHistoryDataSearchNew(parsedSymbol.fromSymbol, from, to)
          .then((response) => {
            const api_data = response.data;

            const transformedKlines = [];

            for (let i = 0; i < api_data["t"].length; i++) {
              transformedKlines.unshift({
                time: api_data["t"][i] * 1000,
                open: api_data["o"][i],
                high: api_data["h"][i],
                low: api_data["l"][i],
                close: api_data["c"][i],
                volume:
                  symbolInfo.type === "index"
                    ? parseFloat(api_data["ca"][i])
                    : parseFloat(api_data["cv"][i]),
              });
            }
            if (to > parseInt(new Date().getTime() / 1000)) {
              onHistoryCallback(transformedKlines);
              if (firstDataRequest) {
                lastBarsCache.set(symbolInfo.full_name, {
                  ...transformedKlines[transformedKlines.length - 1],
                });
              }
            } else {
              // transformedKlines = [];
              // onHistoryCallback(transformedKlines, { noData: true });
              onHistoryCallback([], { noData: true });
            }
          })

          .catch((error) => {
            console.log("[getBars]: Get error", error);
            onErrorCallback(error);
          });

        // THIS IS APPROPRIATE METHOD
        // intraHistoryDataSearch(
        //   parsedSymbol.fromSymbol,
        //   from,
        //   to,
        //   // LocalStorage.getItem("tvAdjusted")
        //   true
        // )
        //   .then((response) => {
        //     const data = response.data;
        //     // if (
        //     //   // (data.Response && data.Response === "Error") ||
        //     //   data.length == 0
        //     // ) {
        //     //   // "noData" should be set if there is no data in the requested period.
        //     //   onHistoryCallback([], {
        //     //     noData: true,
        //     //   });
        //     //   return;
        //     // }
        //     let bars = [];
        //     data.forEach((bar) => {
        //       let date = new Date(bar.date).getTime();

        //       if (date * 1000 >= from && date < to * 1000) {
        //         bars = [
        //           ...bars,
        //           {
        //             time: date,
        //             low: bar.close,
        //             high: bar.close,
        //             open: bar.close,
        //             close: bar.close,
        //             volume:
        //               symbolInfo.type === "index"
        //                 ? parseFloat(bar.curr_amount)
        //                 : parseFloat(bar.curr_volume),
        //           },
        //         ];
        //       }
        //     });
        //     // console.log(bars, "bars is here");
        //     // if (firstDataRequest) {
        //     //   console.log(lastBarsCache, "first");
        //     //   lastBarsCache.set(symbolInfo.full_name, {
        //     //     ...bars[bars.length - 1],
        //     //   });
        //     // }

        //     if (
        //       (resolution == "1" ||
        //         resolution == "15" ||
        //         resolution == "3" ||
        //         resolution == "60") &&
        //       from < new Date().getTime() / 1000 - 365 * 24 * 60 * 60
        //     ) {
        //       onHistoryCallback([], {
        //         noData: true,
        //       });
        //     }
        //     // console.log(`[getBars]: returned ${bars.length} bar(s)`);
        //     onHistoryCallback(bars.reverse(), {
        //       noData: false,
        //     });
        //   })
        //   .catch(() => {
        //     onHistoryCallback([], {
        //       noData: true,
        //     });
        //   });
        // END OF APPROPRIATE METHOD
      } catch (error) {
        // console.log("[getBars]: Get error", error);
        onErrorCallback(error);
      }
    } else {
      try {
        // historyDataSearch(
        //   parsedSymbol.fromSymbol,
        //   from,
        //   to,
        //   // LocalStorage.getItem("tvAdjusted")
        //   true
        // )
        //   .then((response) => {
        //     const data = response.data;
        //     // if (
        //     //   // (data.Response && data.Response === "Error") ||
        //     //   data.length == 0
        //     // ) {
        //     //   // "noData" should be set if there is no data in the requested period.
        //     //   onHistoryCallback([], {
        //     //     noData: true,
        //     //   });
        //     //   return;
        //     // }
        //     let bars = [];
        //     data.reverse().forEach((bar) => {
        //       let date = new Date(bar.date).getTime();
        //       if (date * 1000 >= from && date < to * 1000) {
        //         bars = [
        //           ...bars,
        //           {
        //             time: new Date(bar.date).getTime(),
        //             low: bar.low,
        //             high: bar.high,
        //             open: bar.open,
        //             close: bar.close,
        //             volume:
        //               symbolInfo.type === "index"
        //                 ? parseFloat(bar.amount)
        //                 : parseFloat(bar.volume),
        //           },
        //         ];
        //       }
        //     });
        //     // console.log(bars, "bars is here");
        //     // if (firstDataRequest) {
        //     //   console.log(lastBarsCache, "first");
        //     //   lastBarsCache.set(symbolInfo.full_name, {
        //     //     ...bars[bars.length - 1],
        //     //   });
        //     // }
        //     // console.log(`[getBars]: returned ${bars.length} bar(s)`);
        //     onHistoryCallback(bars, {
        //       noData: false,
        //     });
        //   })
        //   .catch(() => {
        //     onHistoryCallback([], {
        //       noData: true,
        //     });
        //   });
        historyDataSearchNew(
          parsedSymbol.fromSymbol,
          from,
          to,
          LocalStorage.getItem("tvAdjusted")
        )
          .then((response) => {
            const api_data = response.data;
            const transformedKlines = [];

            for (let i = 0; i < api_data["t"].length; i++) {
              transformedKlines.unshift({
                // time: (api_data["t"][i] + 86400) * 1000,
                time: (new Date(api_data["t"][i]).getTime() + 86400) * 1000,
                open: api_data["o"][i],
                high: api_data["h"][i],
                low: api_data["l"][i],
                close: api_data["c"][i],
                volume:
                  symbolInfo.type === "index"
                    ? parseFloat(api_data["amt"][i])
                    : parseFloat(api_data["vol"][i]),
              });
            }

            if (to > parseInt(new Date().getTime() / 1000) - 43200) {
              onHistoryCallback(transformedKlines);
              if (firstDataRequest) {
                lastBarsCache.set(symbolInfo.full_name, {
                  ...transformedKlines[transformedKlines.length - 1],
                });
              }
            } else {
              // onHistoryCallback(transformedKlines, { noData: false });
              onHistoryCallback([], { noData: true });
            }
            // })

            // const data = response.data;

            // if (data.length > 0) {
            // let time;
            // data.reverse().forEach((bar) => {
            //   // get miliseconds in current timezone
            //   time = new Date(bar.date).getTime();
            //   if (from * 1000 <= time && time < to * 1000) {
            //     bars = [
            //       ...bars,
            //       {
            //         time: time,
            //         low: bar.low,
            //         high: bar.high,
            //         open: bar.open,
            //         close: bar.close,
            //         volume:
            //           symbolInfo.type === "index"
            //             ? parseFloat(bar.amount)
            //             : parseFloat(bar.volume),
            //       },
            //     ];
            //   }
            // });
            // onHistoryCallback(bars);
            // } else {

            // }
          })

          .catch((error) => {
            console.log("[getBars]: Get error", error);
            onErrorCallback(error);
          });
      } catch (error) {
        // console.log("[getBars]: Get error", error);
        onErrorCallback(error);
      }
    }
  },

  subscribeBars: (
    symbolInfo,
    resolution,
    onRealtimeCallback,
    subscriberUID,
    onResetCacheNeededCallback
  ) => {
    // console.log(symbolInfo, "Method symbol info");
    // console.log(onRealtimeCallback, "Method on realtime");
    subscribeOnStream(
      symbolInfo,
      resolution,
      onRealtimeCallback,
      subscriberUID,
      onResetCacheNeededCallback,
      lastBarsCache.get(symbolInfo.full_name)
    );
  },

  unsubscribeBars: (subscriberUID) => {
    // unsubscribeFromStream(subscriberUID);
  },
};
